export const checkUserGroupAccess = (userGroup, type) => {
  if (!userGroup) {
    return false;
  } else if (userGroup.isAdmin) {
    return userGroup.isAdmin;
  }

  // ?? USE MENU LIST TITLE FOR TYPE
  switch (type) {
    case "Patient":
      return (
        userGroup.patientModule.patients.list &&
        userGroup.patientModule.patients.read
      );
    case "Hand Hygiene":
      return userGroup.handHygieneModule.handHygieneForm.write; // Nurse only need write access
    case "PPE":
      return userGroup.ppeModule.ppeForm.write; // Nurse only need write access
    case "Narcotics":
      return userGroup.narcoticsModule.narcoticsForm.write;
    case "Patient Care":
      return userGroup.patientCareModule.patientCareForm.write;
    case "Dining Audit":
      return userGroup.diningModule.diningForm.write;

    default:
      return false;
  }
};

export const removeByKey = (key, arr) => {
  // loop through all items of array
  for (let i = 0; i < arr.length; i++) {
    // if array item has said key, then remove it
    if (arr[i].idName === key) {
      arr.splice(i, 1);
    } else if (typeof arr[i].subgroups !== "undefined") {
      // if object doesn't have desired key but has children, call this function
      // on the children array
      removeByKey(key, arr[i].subgroups);
    }
  }
  return arr;
};
